import React from "react";
import { Box, Typography } from "@mui/material";

export const ComingSoon = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    py={8.5}
    width="100%"
    bgcolor="white"
  >
    <Typography variant="body1" fontWeight={600}>
      Your carrier does not currently provide this data
    </Typography>
  </Box>
);
